export const nftContractAddress = "0x23B1257119376923B19C669184F5Fcf5f05c22E8"